import { getClientSideCookieValue } from '@cookies/GetClientSideCookieValue';
import { LOCALE } from '@core/Constants/Locale.constants';
import { Euro } from '@gds/Icons/Paths/Euro';
import { Pound } from '@gds/Icons/Paths/Pound';

import type { FieldDescriptor } from '../../../Entities/FinCalcFields.entity';

const requiredErrorMessage = 'This is a required field.';

const invalidErrorMessage = 'This field is invalid';

const locale = getClientSideCookieValue(LOCALE);

export const UniversalCalculatorFields: FieldDescriptor[] = [
  {
    id: 'deposit',
    type: 'range',
    dataTestId: 'rangeSlider',
    isActive: () => true,
    rangeLabel: ({ messages, calculation }) =>
      calculation?.captiveId === 'vwfs_fr'
        ? messages.financeDepositVwfsFr
        : messages.financeDeposit,
    isValid: ({ value }) => !!value,
    errorMessage: ({ value }) => (!value && requiredErrorMessage) || invalidErrorMessage,
    rightIcon: locale === 'uk' ? <Pound /> : <Euro />,
    currencySymbol: locale === 'uk' ? '£' : '€',
    max: ({ product }) => product?.inputs?.deposit?.max || 0,
    min: ({ product }) => product?.inputs?.deposit?.min || 0,
    step: () => 100,
    readOnly: true,
  },

  {
    id: 'deposit',
    type: 'input',
    dataTestId: 'deposit',
    isActive: () => true,
    label: ({ messages, calculation }) =>
      calculation?.captiveId === 'vwfs_fr'
        ? messages.financeDepositVwfsFr
        : messages.financeDeposit,
    isValid: ({ value }) => !!value,
    errorMessage: ({ value }) => (!value && requiredErrorMessage) || invalidErrorMessage,
    rightIcon: locale === 'uk' ? <Pound /> : <Euro />,
    mask: () => 'currency',
    max: ({ product }) => product?.inputs?.deposit?.max || 0,
    min: ({ product }) => product?.inputs?.deposit?.min || 10,
    step: () => 100,
    readOnly: true,
  },
  {
    id: 'terms',
    type: 'select',
    dataTestId: 'termsDropdown',
    isActive: () => true,
    width: () => 'full',
    label: ({ messages }) => messages.financeMonths,
    isValid: ({ value }) => !!value,
    options: ({ product, messages }) =>
      product?.inputs?.months?.stepInterval?.map?.(step => ({
        label: `${step} ${messages.financeTermLabel}`,
        value: step,
      })) || [],
    errorMessage: ({ value }) => (!value && requiredErrorMessage) || invalidErrorMessage,
  },

  {
    id: 'mileage',
    type: 'select',
    dataTestId: 'mileageDropdown',
    width: () => 'full',
    isActive: ({ productId }) =>
      ['threeWayFinancing', 'twoWayFinancing', 'privateLeasing', 'PCP'].includes(productId),
    label: ({ messages, calculation }) =>
      calculation?.captiveId === 'vwfs_fr'
        ? messages.financeMileageVwfsFr
        : messages.financeMileage,
    isValid: ({ value }) => !!value,
    options: ({ product, messages }) =>
      product?.inputs?.mileage?.stepInterval?.map(step => ({
        label: `${step} ${messages.financeMileageLabel}`,
        value: step,
      })) || [],
  },
];
